var _excluded = ["children", "variant", "style"],
    _excluded2 = ["style"],
    _excluded3 = ["style"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import React from 'react';
import { Platform, StyleSheet } from 'react-native';
import { forwardRef } from 'react';
import { useTheme } from './modules/theme';
import validStyles from './modules/validStyles';
import pickBy from 'lodash.pickby';
import isStyledComponent from './modules/isStyledComponent';
import { useMemo } from 'react';
import get from 'lodash.get';
import getResponsiveValue from './modules/responsiveValue';
import { useDeepCompareMemoize } from 'use-deep-compare-effect';

var reactNative = require('react-native');

var transformProps = (props, theme) => {
  var transformedProps = {};
  var style = {};
  props = pickBy(props, o => o !== undefined);

  for (var key in props) {
    if (Object.prototype.hasOwnProperty.call(validStyles, key)) {
      var {
        platform,
        responsive,
        themeKey,
        prop = 'style'
      } = validStyles[key];
      var val = props[key];

      if (platform.includes(Platform.OS)) {
        if (Array.isArray(val) && responsive) {
          val = getResponsiveValue(val, theme);
        }

        if (typeof themeKey !== 'undefined') {
          var _theme;

          val = ((_theme = theme[themeKey]) === null || _theme === void 0 ? void 0 : _theme[val]) || val;
        }

        ;
        (prop === 'style' ? style : transformedProps)[key] = val;
      } else {
        continue;
      }
    } else if (key === 'style') {
      Object.assign(style, StyleSheet.flatten(props[key]));
    }
  }

  transformedProps['style'] = style;
  return transformedProps;
};

export var styled = function styled(component) {
  var defaultStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var variantsKey = arguments.length > 2 ? arguments[2] : undefined;
  var Target = typeof component === 'string' ? reactNative[component] : isStyledComponent(component) ? component.target : component;
  var Component;
  var displayName = "Styled".concat(Target.displayName || 'Component');
  Component = forwardRef((props, ref) => {
    var {
      children,
      variant = 'default',
      style
    } = props,
        restProps = _objectWithoutProperties(props, _excluded);

    var theme = useTheme() || {};
    var variantProps = useMemo(() => {
      if (variantsKey) {
        var constructedKey = '';
        var computedVariant = Array.isArray(variant) ? getResponsiveValue(variant, theme) : variant;

        if (variantsKey.includes('.')) {
          var [key, ...otherKeys] = variantsKey.split('.');
          constructedKey = "".concat(key, ".").concat(computedVariant, ".").concat(otherKeys.join('.'));
        } else {
          constructedKey = "".concat(variantsKey, ".").concat(computedVariant);
        }

        return get(theme, constructedKey);
      }

      return null;
    }, useDeepCompareMemoize([variant, theme]));

    var _useMemo = useMemo(() => {
      var _transformProps = transformProps(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, typeof defaultStyle === 'function' ? defaultStyle(props) : defaultStyle), variantProps), restProps), {}, {
        style
      }), theme),
          {
        style: transformedStyle
      } = _transformProps,
          transformedProps = _objectWithoutProperties(_transformProps, _excluded3);

      return _objectSpread({
        style: StyleSheet.create({
          style: transformedStyle
        }).style
      }, transformedProps);
    }, useDeepCompareMemoize([defaultStyle, variantProps, style, restProps])),
        {
      style: transformedStyle
    } = _useMemo,
        transformedProps = _objectWithoutProperties(_useMemo, _excluded2);

    return React.createElement(Target, _extends({}, restProps, transformedProps, {
      style: transformedStyle,
      ref: ref
    }), children);
  });
  Component.displayName = displayName;
  Component.target = Target;
  return Component;
};
export { useTheme, ThemeProvider, ThemeConsumer } from './modules/theme';
export { default as validStyles } from './modules/validStyles';
export { default as useVariantProps } from './modules/useVariantProps';